import { FC, MouseEvent, useEffect, useRef, useState } from "react";
import styles from "./PhuketMapWithBeaches.module.scss";
import { PhuketMap } from "../../icons";
import cl from "classnames";
import { useTranslation } from "next-i18next";
import { useCatalogFilter } from "@/lib/hooks/useCatalogFilter";
import { CatalogCheckboxBlock } from "../../blocks/page-specific/Catalog/CatalogFilter/CatalogCheckboxBlock";

const beaches = [
  {
    title: "PANWA",
    pos: {
      left: "155px",
      top: "500px",
    },
  },
  {
    title: "NAI_HARN",
    pos: {
      left: "3px",
      top: "535px",
    },
  },
  {
    title: "KATA_NOI",
    pos: {
      left: "-10px",
      top: "492px",
    },
  },
  {
    title: "KATA",
    pos: {
      left: "0px",
      top: "475px",
    },
  },
  {
    title: "KARON",
    pos: {
      left: "-8px",
      top: "450px",
    },
  },
  {
    title: "PATONG",
    pos: {
      left: "-17px",
      top: "392px",
    },
  },
  {
    title: "KAMALA",
    pos: {
      left: "-20px",
      top: "336px",
    },
  },
  {
    title: "SURIN",
    pos: {
      left: "-24px",
      top: "315px",
    },
  },
  {
    title: "BANG_TAO",
    pos: {
      left: "-19px",
      top: "287px",
    },
  },
  {
    title: "NAITHON",
    pos: {
      left: "-30px",
      top: "240px",
    },
  },
  {
    title: "NAI_YANG",
    pos: {
      left: "-18px",
      top: "190px",
    },
  },
  {
    title: "MAI_KHAO",
    pos: {
      left: "-30px",
      top: "157px",
    },
  },
  {
    title: "NATAI",
    pos: {
      left: "-23px",
      top: "40px",
    },
  },
];

export const PhuketMapWithBeaches: FC<{ isShow?: boolean }> = ({ isShow }) => {
  const { t } = useTranslation("index");
  const { query } = useCatalogFilter();
  const mapRef = useRef<HTMLDivElement>(null);
  const [ids, setIds] = useState<{ id: string; isDisabled: boolean }[]>([]);
  useEffect(() => {
    if (mapRef.current) {
      const foundIds = mapRef.current.querySelectorAll("path[id]");
      
      setIds(
        Array.from(foundIds).map((item) => ({
          id: item.id,
          isDisabled: (document.querySelector(`input[id=${item.id}]`) as HTMLInputElement)?.disabled,
        })),
      );
    }
  }, []);

  const selectedIds = (
    typeof query.phuketDistrict === "string"
      ? [query.phuketDistrict]
      : query.phuketDistrict
  ) as string[];

  return (
    <div
      ref={mapRef}
      className={styles.map}
      onClick={(e: MouseEvent<HTMLDivElement>) => {
        if (!("id" in e.target)) return;
        const id = e.target.id as string;
        const checkbox = e.currentTarget?.querySelector(
          `input[id='${id}']`,
        ) as HTMLInputElement;
        if (checkbox) {
          checkbox.click();
          checkbox.blur();
        }
      }}
    >
      <PhuketMap
        className={cl(styles.map__phuket, isShow && styles['map__phuket--show'])}
        id="FilterMap"
        selectedIds={selectedIds}
        t={t}
        shouldHighlight
      />
      {ids.length > 0 && (
        <CatalogCheckboxBlock
          catalogQuery="phuketDistrict"
          isHidden
          items={ids.map((id) => ({
            value: id.id,
            label: id.id,
            id: id.id,
            isDisabled: id.isDisabled
          }))}
        />
      )}
    </div>
  );
};
